var _circle, _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5013,
    cy: 5.0013,
    r: 3.33333,
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5013,
    cy: 14.1693,
    rx: 5.83333,
    ry: 3.33333,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5016 14.1664C17.5016 15.5471 15.8053 16.6664 13.7342 16.6664C14.3444 15.9995 14.7639 15.1623 14.7639 14.1676C14.7639 13.1717 14.3434 12.3338 13.7321 11.6665C15.8031 11.6665 17.5016 12.7857 17.5016 14.1664Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0016 5C15.0016 6.38071 13.8823 7.5 12.5016 7.5C12.2005 7.5 11.9118 7.44678 11.6445 7.34923C12.0388 6.65582 12.2639 5.85374 12.2639 4.99907C12.2639 4.14503 12.0391 3.3435 11.6454 2.65045C11.9125 2.5531 12.2008 2.5 12.5016 2.5C13.8823 2.5 15.0016 3.61929 15.0016 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.4047c157881bc629d143a3e7d6a60116.svg";
export { ForwardRef as ReactComponent };